/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesPipeSeriesStatus200, GetUsersPreferencesPipeSeriesStatus204, GetUsersPreferencesPipeSeriesStatus401 } from '../types/GetUsersPreferencesPipeSeries'
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesPipeSeries } from '../clients/getUsersPreferencesPipeSeries'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

export const getUsersPreferencesPipeSeriesSuspenseQueryKey = () => [{ url: '/users/preferences/pipe-series/' }] as const

type GetUsersPreferencesPipeSeriesSuspenseQueryKey = ReturnType<typeof getUsersPreferencesPipeSeriesSuspenseQueryKey>

export function getUsersPreferencesPipeSeriesSuspenseQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesPipeSeriesSuspenseQueryKey()
  return queryOptions<GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, ResponseErrorConfig<GetUsersPreferencesPipeSeriesStatus401>, GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesPipeSeries({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/pipe-series/}
 */
export function useGetUsersPreferencesPipeSeriesSuspense<TData = GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, TQueryKey extends QueryKey = GetUsersPreferencesPipeSeriesSuspenseQueryKey>(options: {
  query?: Partial<UseSuspenseQueryOptions<GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, ResponseErrorConfig<GetUsersPreferencesPipeSeriesStatus401>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesPipeSeriesSuspenseQueryKey()

  const queryResult = useSuspenseQuery({
   ...getUsersPreferencesPipeSeriesSuspenseQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesPipeSeriesStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
